define('behavior/model.lock.behavior',['require','exports','module','underscore','marionette','backbone.radio','fukit','fukit','view/request.lock.modal.view','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                    = require('underscore'),
      Mn                   = require('marionette'),
      Radio                = require('backbone.radio'),
      RouteHelper          = require('fukit').RouteHelper,
      ModelUtil            = require('fukit').ModelUtil,
      RequestLockModalView = require('view/request.lock.modal.view'),
      ResolveRouteBehavior = require('fukit').ResolveRouteBehavior;

  var ModelLockBehavior = Mn.Behavior.extend({
    defaults: {
      // the model that needs to be locked
      model: null,
      // the model attribute that stores its id
      modelIdAttribute: 'id',
      // the attribute on the lock model that represents the target model's id
      foreignKeyAttribute: 'templateId',
      // the attribute on the lock model that identifies who owns the lock
      userIdAttribute: 'createUser',
      // the view to request a lock when someone else has it
      requestLockModalView: RequestLockModalView,
      // the model class to use to fetch/update the lock
      lockModelClass: null,
      // the route to navigate back to when the user cancels asking for the lock
      fallbackRoute: null,
      // the params to use to resolve the fallback route (can include @state.key and @model.key syntax)
      fallbackParams: null,
    },

    initialize: function() {
      this.model = this.getOption('model') || this.view.getOption('model');
      this.initLockModel();
      if (!this.model || !this.lockModel) {
        return;
      }
      Radio.request('AppKit.controllerService', 'registerStartInterceptor', this.controllerStartInterceptor, this);
    },

    controllerStartInterceptor: function(controller) {
      var xhr = this.fetchLockModel(this.lockModel);
      return Promise.resolve(ModelUtil.resolvePromise(xhr))
        .bind(this)
        .then(function() {
          if (this.lockModel.isNew()) {
            return ModelUtil.resolvePromise(this.lockModel.save());
          } else if (!this.doesUserOwnLock()) {
            return this.startRequestLockFlow();
          }
        })
        .then(function() {
          var lockModel = this.lockModel;
          var createEventName = this.getCreateEventName();
          var shouldDestroyOnNavigate = true;

          if (createEventName) {
            this.listenTo(Radio.reply('ModelLockBehavior'), createEventName, function() {
              shouldDestroyOnNavigate = false;
            });
          }

          function destroyLock() {
            return ModelUtil.resolvePromise(lockModel.destroy());
          }

          Backbone.history.once('route', function() {
            if (shouldDestroyOnNavigate) {
              destroyLock();
            }
          });

          Radio.request('evicommon.authenticationService', 'registerLogoutInterceptor', destroyLock, this);

          this.once('destroy', function() {
            Radio.request('evicommon.authenticationService', 'deregisterLogoutInterceptor', destroyLock);
          });
        })
        .catch(function(error) {
          console.error('An error occurred during the controller start interceptor:', error);
        });
    },

    initLockModel: function() {
      var lockModelClass = this.getOption('lockModelClass');

      if (!lockModelClass) {
        return;
      }

      var lockModel = new lockModelClass();
      var createEventName = this.getCreateEventName();

      this.lockModel = lockModel;

      if (createEventName) {
        Radio.trigger('ModelLockBehavior', createEventName);
      }

      lockModel.set(this.getOption('foreignKeyAttribute'), this.getModelIdValue());

      return lockModel;
    },

    getModelIdValue: function() {
      var idAttribute = this.getOption('modelIdAttribute');
      if (idAttribute == 'id') {
        return this.model.id;
      }
      return this.model.get(idAttribute);
    },

    getCreateEventName: function() {
      if (this.getModelIdValue()) {
        return 'create:' + this.getOption('foreignKeyAttribute') + ':' + this.getModelIdValue();
      }
      return null;
    },

    doesUserOwnLock: function() {
      var userId = this.lockModel.get(this.getOption('userIdAttribute'));
      var userPrincipalModel = this.getUserPrincipalModel();
      return userId === userPrincipalModel.id;
    },

    fetchLockModel: function(lockModel) {
      return lockModel.fetch();
    },

    getUserPrincipalModel: function() {
      return Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
    },

    startRequestLockFlow: function() {
      var resolve;
      Radio.request('loadingService', 'stopLoading');
      var modalView = this.view
        .buildComponent(
          _.extend(
            {
              type: this.getOption('requestLockModalView'),
              model: this.lockModel,
              visible: true,
            },
            Mn._getValue(this.getOption('modalOptions'), this)
          )
        )
        .on(
          'confirm',
          function() {
            this.initLockModel();
            return ModelUtil.resolvePromise(this.lockModel.save()).then(resolve);
          },
          this
        )
        .on(
          'deny',
          function() {
            if (this.getOption('fallbackRoute')) {
              var params = this.getOption('fallbackParams');
              if (params) {
                params = ResolveRouteBehavior.resolveRouteParams(params, this.model);
              }
              RouteHelper.navigate(this.getOption('fallbackRoute'), params || {}, { trigger: true });
            } else {
              RouteHelper.navigatePrevious();
            }
          },
          this
        );

      return new Promise(function() {
        resolve = arguments[0];
      }).finally(function() {
        Radio.request('loadingService', 'startLoading');
      })
      .catch(function(error) {
        console.error('An error occurred loadingService:', error);
      });
    },
  });

  module.exports = ModelLockBehavior;
});

